export default function (_this) {
  return {
    dashboard (uid, dash, callback) {
      _this.accessRef
        .child('Dashboard')
        .child(uid + '/' + dash)
        .on('value', (snapshot) => {
          callback(snapshot.val())
        })
    },
    admin (uid, callback) {
      _this.accessRef
        .child('Admin')
        .child(uid)
        .on('value', (snapshot) => {
          callback(snapshot.val())
        })
    },
    /**
     * Read access rules
     * @returns {Object}
     */
    async read () {
      const access = {}

      await new Promise((resolve) => {
        _this.accessRef.child('Dashboard').once('value', (snapshot) => {
          access['Dashboard'] = snapshot.val()
          resolve()
        })
      })

      await new Promise((resolve) => {
        _this.accessRef.child('Admin').once('value', (snapshot) => {
          access['Admin'] = snapshot.val()
          resolve()
        })
      })

      return access
    },
    /**
     * Set admin access rule for given user id
     * @param {string} uid - user id
     */
    setUserAsAdmin (uid) {
      _this.root.ref(`access/Admin/${uid}`).set({ all: true }, (err) => {
        if (err) console.error(err)
      })
    },
    /**
     * Remove admin right for given user id
     * @param {string} uid - user id
     */
    removeUserAdminRight (uid) {
      _this.root.ref(`access/Admin/${uid}`).remove((err) => {
        if (err) console.error(err)
      })
    },
    saveDashboardAccess ({ uid, dId, rules }) {
      return new Promise((resolve) => {
        _this.root.ref(`/dashboards/${dId}/sharedWith/${uid}`).set(true)
        _this.accessRef.child(`Dashboard/${uid}/${dId}`)
          .set(rules, () => (resolve()))
      })
    },
    removeDashboardAccess ({ uid, dId }) {
      _this.root.ref(`/dashboards/${dId}/sharedWith/${uid}`).remove()
      _this.accessRef.child(`Dashboard/${uid}/${dId}`).remove()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/access.js